import React from 'react'

import { isToday } from 'date-fns'
import { HiMiniClock, HiOutlineExclamationTriangle } from 'react-icons/hi2'
import { LuCalendar, LuX } from 'react-icons/lu'
import { twMerge } from 'tailwind-merge'

import { Statistic } from '@/components/home/ui/Statistic'

import { useActionItems } from '@/hooks/home/useActionItems'
import { useCalendarToggle } from '@/hooks/home/useCalendarToggle'
import { useActiveOrgId } from '@/hooks/organization/useActiveOrgId'

export const ActionItemStatistics: React.FC = () => {
  const { isVisible: isCalendarVisible, toggle: toggleCalendar } =
    useCalendarToggle()

  const { activeOrgId } = useActiveOrgId()
  const { data: actionItems, isLoading } = useActionItems({
    orgId: activeOrgId,
  })

  if (!actionItems || isLoading) {
    return <Statistic.Skeleton />
  }

  const dueToday = actionItems.data.filter((actionItem) => {
    return actionItem.due_date !== null && isToday(actionItem.due_date)
  })

  return (
    <Statistic label={`Action Items`} value={actionItems.count}>
      <Statistic.Icon icon={HiOutlineExclamationTriangle} variant="red" />
      <Statistic.Footer className="justify-between w-full">
        <div className="flex items-center">
          {dueToday.length > 0 ? (
            <span className="flex items-center gap-x-[6px] text-red-600 dark:text-red-500 text-sm font-medium">
              <HiMiniClock size={16} />
              {dueToday.length} Due Today
            </span>
          ) : (
            <span className="flex items-center text-[13px] text-primary-500 dark:text-primary-400">
              None due today
            </span>
          )}
        </div>
        <button
          onClick={toggleCalendar}
          className={twMerge(
            'flex items-center gap-1.5 text-xs font-medium transition-colors hover:opacity-80',
            !isCalendarVisible
              ? 'text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300'
              : 'text-primary-500 dark:text-primary-400 hover:text-primary-600 dark:hover:text-primary-300',
          )}
        >
          {isCalendarVisible ? (
            <>
              <LuX size={14} />
              <span className="hidden sm:inline">Hide Calendar</span>
            </>
          ) : (
            <>
              <LuCalendar size={14} />
              <span className="hidden sm:inline">Show Calendar</span>
            </>
          )}
        </button>
      </Statistic.Footer>
    </Statistic>
  )
}

ActionItemStatistics.displayName = 'Home.Dashboard.ActionItemStatistics'
